<div
  data-header-class="white"
  class="articles section"
>
  <noda-articles-hero />
  <div
    #articlesStartAnchor
    class="articles__anchor"
  ></div>
  @if (isLoading() | equal: false) {
    <noda-articles-list
      [articles]="articles()"
      (changePage)="handleMobileSwipe($event)"
    />
  } @else {
    <noda-loader />
  }
  @if (needPagination()) {
    <noda-pagination
      [currentCount]="pageSize()"
      [currentPage]="currentPage()"
      [itemsCount]="articlesTotal()"
      (setPage)="changePage($event)"
    />
  }
</div>
